/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestsAppAccessRulePostRequest
 */
export interface AccessRequestsAppAccessRulePostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    app_external_connection_id: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    person_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    app_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePostRequest
     */
    identifier_from_source: string;
}

/**
 * Check if a given object implements the AccessRequestsAppAccessRulePostRequest interface.
 */
export function instanceOfAccessRequestsAppAccessRulePostRequest(value: object): value is AccessRequestsAppAccessRulePostRequest {
    if (!('app_external_connection_id' in value) || value['app_external_connection_id'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    return true;
}

export function AccessRequestsAppAccessRulePostRequestFromJSON(json: any): AccessRequestsAppAccessRulePostRequest {
    return AccessRequestsAppAccessRulePostRequestFromJSONTyped(json, false);
}

export function AccessRequestsAppAccessRulePostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestsAppAccessRulePostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'app_external_connection_id': json['app_external_connection_id'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'app_url': json['app_url'] == null ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source'],
    };
}

export function AccessRequestsAppAccessRulePostRequestToJSON(json: any): AccessRequestsAppAccessRulePostRequest {
    return AccessRequestsAppAccessRulePostRequestToJSONTyped(json, false);
}

export function AccessRequestsAppAccessRulePostRequestToJSONTyped(value?: AccessRequestsAppAccessRulePostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'app_external_connection_id': value['app_external_connection_id'],
        'person_id': value['person_id'],
        'description': value['description'],
        'app_url': value['app_url'],
        'identifier_from_source': value['identifier_from_source'],
    };
}

